import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Typography, InputLabel, Button } from '@mui/material';
import Security from '../../components/Security';
import TextFieldComponent from '../../components/TextField';
import Logo from '../../assets/Images/ForgetPassword.png';
import { forgotPasswordSendEmailAction, clearError } from '../../redux/AuthDuck';
import { useTranslation } from 'react-i18next';
import * as ROUTES from '../../constants/routes';

const ForgetPassword = () => {

    const { t } = useTranslation(['forgetPassword','validations','auth']);

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const error = useSelector(store => store.auth.error);
    const dispatch = useDispatch();

    const onChange = e => {
        const { value } = e.target;
        setEmail(value);
    };

    const sendEmail = () => {
        if (validateUserFields()) {
            dispatch(forgotPasswordSendEmailAction(email)); 
            setEmail('');
        }
    };

    const validateUserFields = () => {
        var error = "";

        if (email === null || email.length === 0
            || /^\s+$/.test(email))
            error = t("validations:errorEmail");
        else if (!validateUserEmail(email))
            error = t("validations:errorEmailFormat");

        setEmailError(error);
        return !error;
    };

    const validateUserEmail = ((email) => {
        var regex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email) ? true : false;
    });
    
    useEffect(() => {
        dispatch(clearError());
    }, [dispatch]);

    return (
        <Security logo={Logo}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <Typography className="title-app" style={{ marginBottom: '5%' }}>
                    {t('title')}
                </Typography>
                <Typography className="label-forget-password" style={{ marginBottom: '5%' }}>
                    {t('description')}
                </Typography>
                <InputLabel className="label-app">{t('emailLabel')}</InputLabel>
                <TextFieldComponent name="email"
                    valueInput={email} type="email"
                    callback={onChange.bind(this)}
                    errorInput={emailError || t(error)}
                />
                <Button variant="contained" className="button-login" disableElevation
                    onClick={() => sendEmail()}>
                    {t('submitButton')}
                </Button>
                <Typography className="link-login" component={Link}
                    to={ROUTES.LOGIN}>
                    {t('loginBack')}
                </Typography>
            </div>
        </Security>
    );
}

export default withRouter(ForgetPassword);